import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { headersInstance } from '../../../../common/utils/HeaderUtils';
import { STATUS_TYPES } from '../../../constants';
import { IEvent } from '../../../models';
import { activeEventResponseSchema } from '../../../utilities/sources/RegistriesSchemaDefintion';
import { fetchServiceEvent } from '../../actions/actionType/services/ServiceEventActionTypes';
import { clearEgressServiceEvent, fetchEgressServiceEventFailure, getEgressServiceEventStarted, getEgressServiceEventSuccess } from '../../actions/sagaActions/services/EgressServiceEventSagaAction';
import {
  clearIngressServiceEvent,
  fetchServiceEventFailure,
  getServiceEventStarted,
  getServiceEventSuccess
} from '../../actions/sagaActions/services/IngressServiceEventSagaActions';
import { FetchServiceEventFailurePayload, FetchServiceEventRequest, IActiveServiceEvent } from '../../actions/types/services/GetAllServiceEventTypes';

/**
 * Call Search Service Events by API
 * @returns api response
 */
export async function callGetServiceEventApi(eventName: string) {
  return apiWrapper.post<IActiveServiceEvent>(
    `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/events/search`,
    {
      events: [
        {
          eventName
        }
      ],
      exactNameMatch: false,
      status: [STATUS_TYPES.ACTIVE]
    },
    headersInstance()
  );
}

/**
 * Call Gets Service Events by API
 * @returns api response
 */
export async function callGetServiceAssociatedEventApi(eventName: string, version: string) {
  const resp = await apiWrapper.get<IEvent[], { errorMessage: string }>(`${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/events/${eventName}/version/${version}`, headersInstance());
  const apiResponse = activeEventResponseSchema.validate(
    resp.responseBody,
    { abortEarly: true }
  );
  if (resp.isError || apiResponse.error) {
    return {
      isError: true
    };
  }
  return {
    eventData: resp.responseBody,
    isError: false
  };
}

export function* getServiceEvent({ eventName, eventType }: FetchServiceEventRequest) {
  let clearAction; let startedAction; let successAction; let failureAction;
    if (eventType === 'ingress') {
      clearAction = clearIngressServiceEvent();
      startedAction = getServiceEventStarted();
      successAction = getServiceEventSuccess;
      failureAction = fetchServiceEventFailure;
    } else {
      clearAction = clearEgressServiceEvent();
      startedAction = getEgressServiceEventStarted();
      successAction = getEgressServiceEventSuccess;
      failureAction = fetchEgressServiceEventFailure;
    }

  try {
    yield put(clearAction);
    yield put(startedAction);
    const { responseBody: data, isError, error } = yield call(callGetServiceEventApi, eventName);
    if (isError) {
      throw error;
    }
    if (data) {
      yield put(successAction(data.events));
    } else {
      throw new Error('No Response');
    }
  } catch (error) {
    const obj: FetchServiceEventFailurePayload = {
      error: String(error)
    };
    yield put(failureAction(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* fetchServiceEventSaga() {
  yield takeLatest(fetchServiceEvent.FETCH_SERVICE_EVENT_REQUEST, getServiceEvent);
}

export const getServiceEventSaga = [fork(fetchServiceEventSaga)];
